module.exports = __webpack_public_path__ + "static/img/operating.cbd288d6.svg";